import { createContext, useContext, useEffect, useState } from "react";
import { CountriesContext } from "./countries.context";
export const CountryContext = createContext({
  countryMap: {},
});

export const CountryProvider = ({ children }) => {
  const { countries } = useContext(CountriesContext);
  const [countryMap, setCountryMap] = useState();
  useEffect(() => {
    const response = countries.reduce((acc, data) => {
      const { name } = data;
      acc[name] = data;
      return acc;
    }, {});
    setCountryMap(response);
  }, [countries]);

  const value = { countryMap };

  return (
    <CountryContext.Provider value={value}>{children}</CountryContext.Provider>
  );
};
